import React, { useCallback, useEffect, useState } from 'react'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import moment from 'moment'
import { reduxForm, formValueSelector } from 'redux-form'
import { INTERVALO_LARGO } from '../../../../config/settings'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import PesadoBrutoChofer0 from './steps/PesadoBrutoChofer0'
import 'moment/locale/es'

const selector = formValueSelector(FORM_PESO_BRUTO)

function PesadoBrutoChofer (props) {
  const { cea, cpe, modo, pesoCabezal } = props
  const [show, setShow] = useState(false)
  const [init, setInit] = useState(false)
  const [timer, setTimer] = useState(0)
  const [fecha, setFecha] = useState(moment(new Date()).format('DD/MM/YYYY hh:mm'))

  const onBlurInput = useCallback(() => {
    if (!show && !cpe && timer === 0) {
      if (document.getElementsByName('numero')[0]) {
        document.getElementsByName('numero')[0].focus()
      }
    }
  }, [show, timer, cpe])

  useEffect(() => {
    const { receiveParametros } = props

    function setUp () {
      onBlurInput()
      props.queryParametrosBruto()
      props.getCpeEnBruto()
      props.setShowFooterPesado(true)
    }

    const intervalDate = setInterval(async () => {
      setFecha(moment(new Date()).format('DD/MM/YYYY hh:mm'))
    }, 1000)

    const intervalParametros = setInterval(async () => {
      const { cpe } = props
      if (!cpe) {
        props.getModoPesajeBruto()
        props.getRepesoBruto()
        props.getEquilibrioBruto()
        props.getPedirConfirmacionChofer()
        props.getEnclavamientoBarrerasBruto()
      }
    }, INTERVALO_LARGO)

    const interval = setInterval(async () => {
      const { cpe, cea, modo, change: formChange, pesoMinimo, repeso } = props

      onBlurInput()

      // si se leyo cp:
      props.getCpeEnBruto()

      // control para dar tiempo a recibir cpe y que no se cierre el dialogo
      if (timer > 0) {
        setTimer(timer => timer - 1)
      }

      if (cpe && !cea) {
        props.requestDatosConsultaCea(cpe.numero)
      }

      // si hay camion pesado pero no esta mostrando dialogo
      if (cpe && !show && !cpe.error) {
        setShow(true)
        setTimer(1)
      }

      if (!cpe && show && timer === 0) {
        setShow(false)
        formChange('numero', '')
        setTimer(0)
      }

      if (modo === 'auto' && cpe) {
        const peso = await props.requestPesoBruto()
        formChange('pesoBruto', peso && peso)

        // si ya no hay camion en balanza
        if (parseInt(peso) < parseInt(pesoMinimo)) {
          if (show) {
            setShow(false)
            formChange('numero', '')
          }

          if (cpe && cpe.numero) {
            props.deleteCpeEnBruto(cpe.numero)
            props.resetConsultaCeaBruto()
            formChange('pesoBruto', '')

            if (repeso === 1) {
              props.updateEnclavamiento(1)
              props.updateParametroInteger('REPESOBR', 0)
            }
          }
        }
      }
    }, 1800)

    if (!receiveParametros && !init) {
      setUp()
      setInit(true)
    }

    return () => {
      clearInterval(interval)
      clearInterval(intervalParametros)
      clearInterval(intervalDate)
    }
  }, [props, show, timer, init, onBlurInput])

  const updateShowBruto = (newValue) => {
    setShow(newValue)
  }

  const borrarCpeBruto = (numero) => {
    const { change: formChange } = props
    setShow(false)
    props.deleteCpeEnBruto(numero)
    formChange('numero', '')
    onBlurInput()
  }

  const handleSubmit = async () => {
    const { numero, change: formChange, pesoMinimo } = props
    if (!isNaN(numero)) {
      const peso = await props.requestPesoBruto()
      if (parseInt(peso) > parseInt(pesoMinimo) || modo === 'manual') {
        props.admitibleEnBruto(numero)
        setShow(true)
        setTimer(1)
      } else {
        console.log('Peso incorrecto --> ', peso)
      }
    }
    formChange('numero', '')
  }

  return (
    <PesadoBrutoChofer0
      show={show}
      cpe={cpe}
      cea={cea}
      fecha={fecha}
      pesoCabezal={pesoCabezal}
      handleSubmit={handleSubmit}
      borrarCpeBruto={borrarCpeBruto}
      modo={modo}
      pedirConfirmacion={props.pedirConfirmacion}
      onBlurInput={onBlurInput}
      updateShowBruto={updateShowBruto}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    cea: state.pesado.consultaCeaBruto || null,
    cpe: state.pesado.cpePesadoBruto || null,
    enclavamiento: state.pesado.equilibrioBruto,
    modo: state.pesado.pesajeBruto,
    numero: selector(state, 'numero'),
    pedirConfirmacion: state.pesado.pedirConfirmacion,
    pesoCabezal: selector(state, 'pesoBruto'),
    pesoMinimo: state.pesado.pesoMinimo,
    receiveParametros: state.pesado.receiveParametrosBruto,
    repeso: state.pesado.repesoBruto,
    urlBruto: state.pesado.urlBruto
  }
}
const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO,
  destroyOnUnmount: false,
  // enableReinitialize: true,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(PesadoBrutoChofer))
